const defaultData = {
  card1: true,
  card2: true,
  card3: true,
  card4: true,
  card5: true,
  card6: true,
};

const getDataFromStorage = (storagedData, initialData) => {
  for (const key in storagedData) {
    initialData[key] = storagedData[key];
  }
  return initialData;
};

const initialState = window.localStorage.getItem("cards-comparisons-quality")
  ? getDataFromStorage(
      JSON.parse(window.localStorage.getItem("cards-comparisons-quality")),
      defaultData,
    )
  : defaultData;

const cardsOfQualityComparisons = (state = initialState, action) => {
  switch (action.type) {
    case "CHANGE_CARDS_COMPARISONS_QUALITY":
      return {
        card1: action.card1,
        card2: action.card2,
        card3: action.card3,
        card4: action.card4,
        card5: action.card5,
        card6: action.card6,
      };
    default:
      return state;
  }
};

export default cardsOfQualityComparisons;
